import {APP_SETUP_CONFIGURE} from "../app/AppActions";
import {
  ORDER_CHANGE_BILLING_ADDRESS,
  ORDER_CHANGE_CUSTOMER,
  ORDER_CHANGE_PERSONA,
  ORDER_CHANGE_SHIPPING_ADDRESS, ORDER_FORM_RESET
} from "../order/OrderActions";

export const configure = (newValues, oldValues, defaultMerchantId) => (dispatch) => {
  if (newValues.merchantId === defaultMerchantId) {
    dispatch({
      type: ORDER_CHANGE_CUSTOMER,
      action: oldValues.customer
    });

    dispatch({
      type: ORDER_CHANGE_PERSONA,
      action: oldValues.persona
    });

    dispatch({
      type: ORDER_CHANGE_SHIPPING_ADDRESS,
      action: oldValues.shippingAddress
    });

    dispatch({
      type: ORDER_CHANGE_BILLING_ADDRESS,
      action: oldValues.billingAddress
    });
  } else {
    dispatch({
      type: ORDER_FORM_RESET
    });
  }

  dispatch({
    type: APP_SETUP_CONFIGURE,
    value: newValues
  });
};

const loadScript = (url, callback) => {
  const tag = document.createElement('script');
  tag.async = false;
  tag.src = url;
  tag.onload = () => {
    callback();
  };
  document.head.appendChild(tag);
};

export const loadWidget = (environment, callback) => () => {
  loadScript(environment.widgetUrl, callback);
};

export const loadBridge = (environment, callback) => () => {
  loadScript(environment.bridgeUrl, callback);
};



// WEBPACK FOOTER //
// ./src/setup/SetupActions.js